import { useState } from 'react';
import { ListTodo, CheckCircle2, Upload } from 'lucide-react';
import { ExcelImportDialog } from '../directory/ExcelImportDialog';
import { useInvalidateOnboardingStatus } from '../../hooks/useOnboarding';
import type { OnboardingStatus } from '../../lib/onboardingApi';

// Step "Task-uri" — reuses the generic directory Excel import dialog
// (CLE-229/230) with entityType="tasks" to bulk-import tasks during
// onboarding. Rows are matched against existing projects (by cod) and
// team members (by email); unresolved assignees are left unassigned.

interface StepTasksProps {
  status: OnboardingStatus;
}

export function StepTasks({ status }: StepTasksProps) {
  const [showImport, setShowImport] = useState(false);
  const invalidateStatus = useInvalidateOnboardingStatus();
  const count = status.counts.tasks;

  return (
    <section className="rounded-lg border border-gray-200 bg-white p-5">
      <div className="flex items-start gap-3">
        <div className="rounded-md bg-brand-50 p-2 text-brand-600">
          <ListTodo className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-900">Importați task-urile</h3>
          <p className="mt-1 text-sm text-gray-500">
            Încărcați un fișier Excel cu task-urile existente (titlu, proiect, status, prioritate,
            responsabil) sau descărcați șablonul pentru a-l completa. Proiectele trebuie create deja
            (identificate prin cod).
          </p>

          <div className="mt-3 flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => setShowImport(true)}
              className="inline-flex items-center gap-2 rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
            >
              <Upload className="h-4 w-4" />
              Importă task-uri
            </button>
            {count > 0 && (
              <span className="inline-flex items-center gap-1 text-sm text-green-700">
                <CheckCircle2 className="h-4 w-4" />
                {count} {count === 1 ? 'task importat' : 'task-uri importate'}
              </span>
            )}
          </div>
        </div>
      </div>

      {showImport && (
        <ExcelImportDialog
          entityType="tasks"
          onClose={() => setShowImport(false)}
          onImportComplete={() => {
            void invalidateStatus();
          }}
        />
      )}
    </section>
  );
}
